export function newGuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function parseOptions(options): any {
  let optionsJson = [];
  try {
    optionsJson = JSON.parse(options);
    return optionsJson;
  } catch (e) {
    // console.log('Failed to parse options for checkbox multi question.');
    return [];
  }
}

export function getUniqueName(controlType: string): string {
  return `${controlType}-${newGuid()}`;
}

export function stripCurrency(text): string {

  try {
    return text.replace(/ /g, '').replace(/R/g, '');
  } catch (e) {
    // console.log('Failed to parse options for checkbox multi question.');
    return text;
  }
}

export function getParam(parameters: any[], name: string): any {
  return parameters?.find(p => p?.parameter === name);
}

export function scrollToItem(section: string): void {
  const el = document.getElementById(section);
  if (el) {
    el.scrollIntoView(true);
    el.scrollIntoView({behavior: 'smooth'});
    const scrolledY = window.scrollY;
    if (scrolledY) {
      window.scroll({
        top: scrolledY - 80,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
}
